module.exports = __webpack_public_path__ + "img/file-icon_ppt.e18ad17e.svg";